import About from './About';
import Election from './Election';
import Help from './Help';
import Home from './Home';
import NotFound from './NotFound';
import Unavailable from './Unavailable';
import ReceiptConsult from './ReceiptConsult/ReceiptConsult';
import ResultVoting from './ResultVoting';
import SetLocale from './SetLocale';

export {
  Home,
  Election,
  ResultVoting,
  NotFound,
  About,
  Help,
  ReceiptConsult,
  SetLocale,
  Unavailable,
};



// WEBPACK FOOTER //
// ./src/features/election/index.ts